/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 9L9 22M2 9H22M9 15L22 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 9H22V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03969 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V9Z"
				fill="currentColor"
			/>
			<path
				d="M9 9L9 22M2 9H22M9 15L22 15M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.91667 1.25C6.36671 1.25 5.59174 1.25 4.9559 1.42037C3.23044 1.88271 1.88271 3.23044 1.42037 4.9559C1.25 5.59174 1.25 6.36671 1.25 7.91667C1.25 8.22666 1.25 8.38165 1.28407 8.50882C1.37654 8.85391 1.64609 9.12346 1.99118 9.21593C2.11835 9.25 2.27334 9.25 2.58333 9.25H10H21.4167C21.7267 9.25 21.8817 9.25 22.0088 9.21593C22.3539 9.12346 22.6235 8.85391 22.7159 8.50882C22.75 8.38165 22.75 8.22666 22.75 7.91667C22.75 6.36671 22.75 5.59174 22.5796 4.9559C22.1173 3.23044 20.7696 1.88271 19.0441 1.42037C18.4083 1.25 17.6333 1.25 16.0833 1.25H7.91667ZM7.91667 22.75C6.36671 22.75 5.59174 22.75 4.9559 22.5796C3.23044 22.1173 1.88271 20.7696 1.42037 19.0441C1.25 18.4083 1.25 17.6333 1.25 16.0833V12.35C1.25 11.7899 1.25 11.5099 1.35899 11.296C1.45487 11.1078 1.60785 10.9549 1.79601 10.859C2.00992 10.75 2.28995 10.75 2.85 10.75H7.65C8.21005 10.75 8.49008 10.75 8.70399 10.859C8.89215 10.9549 9.04513 11.1078 9.14101 11.296C9.25 11.5099 9.25 11.7899 9.25 12.35L9.25 21.4167C9.25 21.7267 9.25 21.8817 9.21593 22.0088C9.12346 22.3539 8.85391 22.6235 8.50882 22.7159C8.38165 22.75 8.22666 22.75 7.91667 22.75ZM12.35 17.25C11.7899 17.25 11.5099 17.25 11.296 17.359C11.1078 17.4549 10.9549 17.6078 10.859 17.796C10.75 18.0099 10.75 18.2899 10.75 18.85V21.15C10.75 21.7101 10.75 21.9901 10.859 22.204C10.9549 22.3922 11.1078 22.5451 11.296 22.641C11.5099 22.75 11.7899 22.75 12.35 22.75H18.1667C20.698 22.75 22.75 20.698 22.75 18.1667C22.75 17.6604 22.3396 17.25 21.8333 17.25L12.35 17.25ZM21.15 15.75C21.7101 15.75 21.9901 15.75 22.204 15.641C22.3922 15.5451 22.5451 15.3922 22.641 15.204C22.75 14.9901 22.75 14.7101 22.75 14.15V12.35C22.75 11.7899 22.75 11.5099 22.641 11.296C22.5451 11.1078 22.3922 10.9549 22.204 10.859C21.9901 10.75 21.7101 10.75 21.15 10.75H12.35C11.7899 10.75 11.5099 10.75 11.296 10.859C11.1078 10.9549 10.9549 11.1078 10.859 11.296C10.75 11.5099 10.75 11.7899 10.75 12.35V14.15C10.75 14.7101 10.75 14.9901 10.859 15.204C10.9549 15.3922 11.1078 15.5451 11.296 15.641C11.5099 15.75 11.7899 15.75 12.35 15.75L21.15 15.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9 9H22V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005M9 9V15M9 9H5.5M9 15L9 22M9 15H18.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 9H9M9 9H22M9 9V15M9 15L9 22M9 15L22 15M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g opacity="0.32">
				<path
					d="M1.25 16.0833V12.35C1.25 11.7899 1.25 11.5099 1.35899 11.296C1.45487 11.1078 1.60785 10.9549 1.79601 10.859C2.00992 10.75 2.28995 10.75 2.85 10.75H7.65C8.21005 10.75 8.49008 10.75 8.70399 10.859C8.89215 10.9549 9.04513 11.1078 9.14101 11.296C9.25 11.5099 9.25 11.7899 9.25 12.35L9.25 21.4167C9.25 21.7267 9.25 21.8817 9.21593 22.0088C9.12346 22.3539 8.85391 22.6235 8.50882 22.7159C8.38165 22.75 8.22666 22.75 7.91667 22.75C6.36671 22.75 5.59174 22.75 4.9559 22.5796C3.23044 22.1173 1.88271 20.7696 1.42037 19.0441C1.25 18.4083 1.25 17.6333 1.25 16.0833Z"
					fill="currentColor"
				/>
				<path
					d="M10.75 21.15V18.85C10.75 18.2899 10.75 18.0099 10.859 17.796C10.9549 17.6078 11.1078 17.4549 11.296 17.359C11.5099 17.25 11.7899 17.25 12.35 17.25L21.8333 17.25C22.3396 17.25 22.75 17.6604 22.75 18.1667C22.75 20.698 20.698 22.75 18.1667 22.75H12.35C11.7899 22.75 11.5099 22.75 11.296 22.641C11.1078 22.5451 10.9549 22.3922 10.859 22.204C10.75 21.9901 10.75 21.7101 10.75 21.15Z"
					fill="currentColor"
				/>
				<path
					d="M22.75 12.35V14.15C22.75 14.7101 22.75 14.9901 22.641 15.204C22.5451 15.3922 22.3922 15.5451 22.204 15.641C21.9901 15.75 21.7101 15.75 21.15 15.75L12.35 15.75C11.7899 15.75 11.5099 15.75 11.296 15.641C11.1078 15.5451 10.9549 15.3922 10.859 15.204C10.75 14.9901 10.75 14.7101 10.75 14.15V12.35C10.75 11.7899 10.75 11.5099 10.859 11.296C10.9549 11.1078 11.1078 10.9549 11.296 10.859C11.5099 10.75 11.7899 10.75 12.35 10.75H21.15C21.7101 10.75 21.9901 10.75 22.204 10.859C22.3922 10.9549 22.5451 11.1078 22.641 11.296C22.75 11.5099 22.75 11.7899 22.75 12.35Z"
					fill="currentColor"
				/>
			</g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.91667 1.25C6.36671 1.25 5.59174 1.25 4.9559 1.42037C3.23044 1.88271 1.88271 3.23044 1.42037 4.9559C1.25 5.59174 1.25 6.36671 1.25 7.91667C1.25 8.22666 1.25 8.38165 1.28407 8.50882C1.37654 8.85391 1.64609 9.12346 1.99118 9.21593C2.11835 9.25 2.27334 9.25 2.58333 9.25H10H21.4167C21.7267 9.25 21.8817 9.25 22.0088 9.21593C22.3539 9.12346 22.6235 8.85391 22.7159 8.50882C22.75 8.38165 22.75 8.22666 22.75 7.91667C22.75 6.36671 22.75 5.59174 22.5796 4.9559C22.1173 3.23044 20.7696 1.88271 19.0441 1.42037C18.4083 1.25 17.6333 1.25 16.0833 1.25H7.91667Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
